import React from 'react';
import './MobileServices.css';
import { residentialServices, commercialServices, emergencyServices } from './servicesData';

const Category = ({ title, items }) => (
  <div className="mobile-services-category">
    <h3>{title}</h3>
    <ul>
      {items.map((s, i) => (
        <li key={i}>
          <div className="service-name">{s.name}</div>
        </li>
      ))}
    </ul>
  </div>
);

const MobileServices = () => {
  return (
    <div className="mobile-services">
      <Category title="Emergency" items={emergencyServices} />
      <Category title="Commercial" items={commercialServices} />
      <Category title="Residential" items={residentialServices} />
    </div>
  );
};

export default MobileServices;
